import { render, staticRenderFns } from "./ModalConfirmarFluxoAlteracaoOrcamento.vue?vue&type=template&id=8be32c7a&scoped=true"
import script from "./ModalConfirmarFluxoAlteracaoOrcamento.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmarFluxoAlteracaoOrcamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalConfirmarFluxoAlteracaoOrcamento.vue?vue&type=style&index=0&id=8be32c7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be32c7a",
  null
  
)

export default component.exports